/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.list-sort\":\"Vertikal liste med sorterende pil\"}");